<template>
	<div>
		<div class="px-2">
			<h5
					v-if="data.title"
					class="text--darken-3 font-weight-bold grey--text my-2 text-subtitle-2"
			>
				{{ data.title }}
			</h5>
			<v-img :aspect-ratio="data.aspectRatio || 1" :src="data.src"></v-img>
			<span v-if="data.caption" class="grey--text text-caption">
        {{ data.caption }}
      </span>
		</div>

		<v-divider class="mb-4 mt-4 opacity-70"></v-divider>
	</div>
</template>

<script>
export default {
	name: 'MenuImage',
	components: {},
	props: {
		data: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {};
	},
	computed: {
		formIsDirty() {
			return this.$store.state.formState.isDirty;
		}
	},
	methods: {}
};
</script>

<style lang="scss" scoped></style>
